module.exports = __webpack_public_path__ + "static/img/DEV3-B-d0PvMF.e04d45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/DEV3-B-d0PvMF.png
// module id = fcSD
// module chunks = 16